"use client"
import React from 'react';
import { FaTwitter, FaFacebook, FaLinkedin, FaWhatsapp, FaLink } from 'react-icons/fa';
import { toast } from 'react-hot-toast';

const SocialShareButtons = ({ url, title }) => {
  // Get the current URL if not provided
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  
  // Handle copy link to clipboard
  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      toast.success('Link copied to clipboard!');
    }).catch(() => {
      toast.error('Failed to copy link');
    });
  };

  return (
    <div className="flex flex-col items-center mb-8">
      <h3 className="text-lg font-semibold text-gray-700 mb-3">Share this article</h3>
      <div className="flex space-x-4">
        <a
          href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(title)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="transition-transform hover:scale-110"
          aria-label="Share on Twitter"
        >
          <div className="bg-[#1DA1F2] text-white p-3 rounded-full">
            <FaTwitter size={18} />
          </div>
        </a>
        
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="transition-transform hover:scale-110"
          aria-label="Share on Facebook"
        >
          <div className="bg-[#4267B2] text-white p-3 rounded-full">
            <FaFacebook size={18} />
          </div>
        </a>
        
        <a
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="transition-transform hover:scale-110"
          aria-label="Share on LinkedIn"
        >
          <div className="bg-[#0077B5] text-white p-3 rounded-full">
            <FaLinkedin size={18} />
          </div>
        </a>
        
        <a
          href={`https://api.whatsapp.com/send?text=${encodeURIComponent(title + ' ' + shareUrl)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="transition-transform hover:scale-110"
          aria-label="Share on WhatsApp"
        >
          <div className="bg-[#25D366] text-white p-3 rounded-full">
            <FaWhatsapp size={18} />
          </div>
        </a>
        
        <button
          onClick={copyToClipboard}
          className="transition-transform hover:scale-110"
          aria-label="Copy link"
        >
          <div className="bg-gray-700 text-white p-3 rounded-full">
            <FaLink size={18} />
          </div>
        </button>
      </div>
    </div>
  );
};

export default SocialShareButtons; 